/**
 * Loop Breaker - Safety net for variant selection
 * Minimal production version with essential warnings
 */
(function() {
  // Track variables to detect loops
  let lastVariantId = null;
  let updateCounter = 0;
  let lastUpdateTime = 0;
  
  // Original methods storage
  const originalMethods = {};
  
  // Patch no-ajax-variants if it exists
  const noAjaxVariants = document.querySelector('no-ajax-variants');
  if (noAjaxVariants) {
    // Patch updateFormInput
    if (typeof noAjaxVariants.updateFormInput === 'function') {
      originalMethods.updateFormInput = noAjaxVariants.updateFormInput;
      
      noAjaxVariants.updateFormInput = function(variant) {
        // Only detect loops for the same variant ID
        if (variant && variant.id === lastVariantId) {
          const now = Date.now();
          if (now - lastUpdateTime < 500) {
            updateCounter++;
            if (updateCounter > 3) {
              
              // Do minimum necessary work without triggering events
              const forms = document.querySelectorAll('form[action*="/cart/add"]');
              forms.forEach(form => {
                const idInput = form.querySelector('input[name="id"]');
                if (idInput && idInput.value !== variant.id.toString()) {
                  idInput.value = variant.id;
                }
              });
              return;
            }
          } else {
            updateCounter = 1;
          }
          lastUpdateTime = now;
        } else {
          updateCounter = 1;
          lastVariantId = variant ? variant.id : null;
          lastUpdateTime = Date.now();
        }
        
        return originalMethods.updateFormInput.apply(this, arguments);
      };
    }
    
    // Patch handleVariantChange
    if (typeof noAjaxVariants.handleVariantChange === 'function') {
      originalMethods.handleVariantChange = noAjaxVariants.handleVariantChange;
      
      noAjaxVariants.handleVariantChange = function(event) {
        // Skip events already marked as blocked
        if (event && event._loopBreakerBlocked) {
          console.warn('Loop Breaker: Blocking recursive event to prevent infinite loop');
          return;
        }
        
        // Mark this event as handled
        if (event) {
          event._handledByLoopBreaker = true;
        }
        
        return originalMethods.handleVariantChange.apply(this, arguments);
      };
    }
  }
  
  // Patch bundle-options if it exists
  const bundleOptions = document.querySelector('bundle-options');
  if (bundleOptions) {
    if (typeof bundleOptions.updateUI === 'function') {
      originalMethods.bundleUpdateUI = bundleOptions.updateUI;
      
      bundleOptions.updateUI = function() {
        // Track which bundle is selected
        const selectedRadio = this.querySelector('input[type="radio"]:checked');
        const selectedValue = selectedRadio ? selectedRadio.value : null;
        
        // Prevent excessive updates to the same value
        if (this._lastSelectedBundleValue === selectedValue && this._bundleUpdateCount > 3) {
          console.warn(`Loop Breaker: Bundle UI updated too many times with same value "${selectedValue}". Limiting updates.`);
          return;
        }
        
        // Track update count
        if (this._lastSelectedBundleValue === selectedValue) {
          this._bundleUpdateCount = (this._bundleUpdateCount || 0) + 1;
        } else {
          this._bundleUpdateCount = 1;
          this._lastSelectedBundleValue = selectedValue;
        }
        
        return originalMethods.bundleUpdateUI.apply(this, arguments);
      };
    }
  }
  
  // Add emergency function (keep this for safety)
  window.emergencyBreakLoop = function() {
    console.warn('==== EMERGENCY LOOP BREAKER ACTIVATED ====');
    console.warn('This will disable variant selection functionality.');
    console.warn('Reload the page to restore normal operation.');
    
    // Replace event handlers with no-ops
    if (noAjaxVariants) {
      noAjaxVariants.handleVariantChange = function() {
        console.warn('Loop Breaker: Blocked variant change handler (emergency mode)');
      };
      noAjaxVariants.updateFormInput = function(variant) {
        console.warn(`Loop Breaker: Blocked form input update for variant ${variant?.id} (emergency mode)`);
      };
      noAjaxVariants.handleBundleOptionChange = function() {
        console.warn('Loop Breaker: Blocked bundle option change handler (emergency mode)');
      };
    }
    
    if (bundleOptions) {
      bundleOptions.updateUI = function() {
        console.warn('Loop Breaker: Blocked bundle updateUI (emergency mode)');
      };
    }
    
    // Remove event listeners
    const formInputs = document.querySelectorAll('input[type="radio"], input[name="id"]');
    formInputs.forEach(input => {
      input.onchange = null;
      const newInput = input.cloneNode(true);
      if (input.parentNode) {
        input.parentNode.replaceChild(newInput, input);
      }
    });
    
    return 'Emergency loop breaking applied. Reload page to reset.';
  };
  
  // Log initialization only once
  console.info('Loop Breaker: Safety net initialized');
})(); 